import * as React from 'react';

import Icon from 'components/atoms/Icon';
import TutorialArrow from 'components/molecules/Tutorial/TutorialArrow';
import i18n from 'helper/i18n';

export const LIST_ENTRIES = {
	recipe: 'recipe',
	workout: 'workout',
	task: 'task',
	tip: 'tip',
};
export type ListEntryEnumType = keyof typeof LIST_ENTRIES;

const TutorialFeedOverview = () => (
	<React.Fragment>
		<TutorialArrow />
		<h2 className="m-tutorial__title">{i18n('react.impulsCoach.components.tutorialFeedOverview.title')}</h2>
		<p className="m-tutorial__text">{i18n('react.impulsCoach.components.tutorialFeedOverview.text')}</p>
		<ul className="m-tutorial-content m-tutorial-content--tiled">
			{(Object.keys(LIST_ENTRIES) as ListEntryEnumType[]).map((entry: ListEntryEnumType) => (
				<li key={entry} className="m-tutorial-content__item">
					<span className="m-tutorial-content__icon">
						<Icon iconName={entry} />
					</span>
					<span className="m-tutorial-content__text">
						{i18n(`react.impulsCoach.components.tutorialFeedOverview.list.${entry}`)}
					</span>
				</li>
			))}
		</ul>
	</React.Fragment>
);

export default TutorialFeedOverview;
